import { Amplify } from "aws-amplify";

import { config } from "../config";

let configured = false;

export function configureAmplify(): void {
  if (configured) return;

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.clientId,
        loginWith: {
          oauth: {
            domain: config.cognito.domain,
            scopes: ["openid", "email", "profile"],
            redirectSignIn: [config.cognito.redirectUri],
            redirectSignOut: [config.cognito.logoutUri],
            responseType: "code",
          },
        },
      },
    },
  });

  configured = true;
}
